import _ from 'lodash';
import React from 'react';
import { connect } from 'react-redux';
import { Row, Col } from 'antd';
import Item from './item';
import Custom from './custom';
import Api from '../../services/api';

/**
 * 作品列表
 * 
 * @class ProjectList
 * @extends {React.Component}
 */
class ProjectList extends React.Component {

    items = () => {
        let { data = [], isCustom = false, project, intlr } = this.props;
        const { syncLabel, searchText } = project;
        if (isCustom && _.isArray(data)) {
            // 排序
            data = Api.ProjectService.sortBy(data, 'createdAtReverse');
            // 搜索
            data = Api.ProjectService.search(data, searchText);
        } else {
            // 搜索
            data = Api.ProjectService.searchExample(data, searchText, intlr.langKey === 'zh' ? intlr.langKey : 'en');
        }
        let items = [];
        isCustom && items.push(<Custom key="custom" />);
        if (!_.isEmpty(data) && syncLabel !== 'syncing') {
            data = data.filter((d) => !(d.hasOwnProperty('isDeleted') && d.isDeleted));
            data.forEach((item, index) => {
                if (item.hasOwnProperty('id')) {
                    items.push(<Item key={item.id} data={item} isCustom={isCustom} />);
                    return;
                }
                items.push(<Item key={index} data={item} isCustom={isCustom} />);
            });
        }
        return items;
    }

    render() {
        return (
            <section className="tab-content-container">
                <Row gutter={24} style={{margin: '0'}}>
                    {
                        this.items().map((i, index) => (
                            <Col key={index} xs={24} sm={12} md={8} lg={6} xl={6} xxl={4} style={{padding: '12px'}}>{i}</Col>
                        ))
                    }
                </Row>
            </section>
        );
    }
}

const mapStateToProps = state => ({
    intlr: state.intlr,
    project: state.project
});

export default connect(
    mapStateToProps
)(ProjectList);